module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_5_m.9e7d5d9c580efd44608d33e20af34044.png";